import { render, staticRenderFns } from "./blob.vue?vue&type=template&id=0a4b676c&"
import script from "./blob.vue?vue&type=script&lang=js&"
export * from "./blob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports